<template>
    <div class="n-flex n-flex-a-c n-flex-dr-c n-flex-j-c n-h-1">
        <h1 class="n-col-1 n-text-center n-mt-6 n-c-base"
            style="font-size: 50px">{{message}}</h1>
    </div>
</template>
<script >
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';

    export default {
        name: 'NoAuth',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                message: null
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setMenuStatus'])),

            NMounted () {
                this.message = '没操作权限'
            }
        }),
        components: {
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss">
</style>